import { render } from "./courierComponent.vue?vue&type=template&id=5858c14f"
import script from "./courierComponent.vue?vue&type=script&lang=js"
export * from "./courierComponent.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__